import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db5b5d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "o-field tw-mb-4" }
const _hoisted_2 = { class: "o-field__label label" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  grouped: "",
  "group-multiline": "",
  class: "no-grow tw-flex"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))


const __default__ = {
  name: "JourneyPathModalSearchItem",
};
import { computed, toRefs } from "vue";
import TouchpointSearch from "./TouchpointSearch.vue";
import {
  TPossibleFirstLevelNames,
  TLevelObject,
  TConfigurationObject,
  TLevelComparisonObject,
} from "../../Pages/JourneyPaths/Typings/JourneyPathTypes";
import { UseStringHelper } from "../../Helper/Functional/UseStringHelper";

interface IStaticProps {
  title: string;
  subtitle: string;
  buttonText: string;
  configKey: string | "first" | "last" | "anywhere" | "comparison";
  twoDepth: boolean;
  twoDepthKeys: string[];
  twoDepthLabelImmediately: string;
  icons: string[];
  nativeValues: string[];
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    data: null,
    allTaxonomiesData: null,
    staticProps: null
  },
  emits: ["updateConfig", "updateAnywhere"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "updateConfig", val: TLevelObject[] | TLevelComparisonObject[] | string): void;
  (e: "updateAnywhere", val: "or" | "and"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data: TConfigurationObject;
  allTaxonomiesData: TPossibleFirstLevelNames;
  staticProps: IStaticProps;
}




const { data, allTaxonomiesData, staticProps } = toRefs(props);

const {
  buttonText,
  configKey,
  icons,
  nativeValues,
  subtitle,
  title,
  twoDepth,
  twoDepthKeys,
  twoDepthLabelImmediately,
} = staticProps.value;

const computedConfigData = computed({
  get() {
    return data.value[configKey];
  },
  set(val) {
    emits("updateConfig", val);
  },
});

const computedAnywherConnector = computed({
  get() {
    return data.value.anywhere_connector;
  },
  set(val) {
    emits("updateAnywhere", val);
  },
});

const computedComparisonImmediate = computed({
  get() {
    return data.value["comparison"];
  },
  set(val) {
    emits("updateConfig", val);
  },
});

const { capitalise } = UseStringHelper();

return (_ctx: any,_cache: any) => {
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_checkbox = _resolveComponent("o-checkbox")!
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_radio = _resolveComponent("o-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(title)), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(subtitle)), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedConfigData), (first, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'journey_search_first_field' + index
      }, [
        (!_unref(twoDepth))
          ? (_openBlock(), _createBlock(TouchpointSearch, {
              key: 'journey_search_first_search' + index,
              "touchpoint-query": _unref(computedConfigData)[index],
              "onUpdate:touchpoint-query": ($event: any) => ((_unref(computedConfigData)[index]) = $event),
              "all-taxonomies-data": _unref(allTaxonomiesData)
            }, null, 8, ["touchpoint-query", "onUpdate:touchpoint-query", "all-taxonomies-data"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(twoDepthKeys), (label, deeperIndex) => {
                return (_openBlock(), _createBlock(_component_o_field, {
                  key: label + deeperIndex,
                  label: _unref(capitalise)(Object.keys(first)[deeperIndex])
                }, {
                  default: _withCtx(() => [
                    _createVNode(TouchpointSearch, {
                      "touchpoint-query": _unref(computedConfigData)[index][label],
                      "onUpdate:touchpoint-query": ($event: any) => ((_unref(computedConfigData)[index][label]) = $event),
                      "all-taxonomies-data": _unref(allTaxonomiesData)
                    }, null, 8, ["touchpoint-query", "onUpdate:touchpoint-query", "all-taxonomies-data"])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ])),
        _createElementVNode("div", null, [
          (_unref(twoDepth))
            ? (_openBlock(), _createBlock(_component_o_field, {
                key: 0,
                label: _unref(twoDepthLabelImmediately)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_checkbox, {
                    modelValue: _unref(computedComparisonImmediate)[index].immediately,
                    "onUpdate:modelValue": ($event: any) => ((_unref(computedComparisonImmediate)[index].immediately) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1032, ["label"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createVNode(_component_o_field, {
      grouped: "",
      "grouped-multiline": "",
      class: "has-addons"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_field, {
          class: _normalizeClass({ 'no-grow': _unref(twoDepth) })
        }, {
          default: _withCtx(() => [
            (!_unref(twoDepth))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button is-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(computedConfigData).push({})))
                }, _toDisplayString(_unref(buttonText)), 1))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "button is-primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(computedConfigData).push({ before: {}, after: {}, immediately: false })))
                }, _toDisplayString(_unref(buttonText)), 1))
          ]),
          _: 1
        }, 8, ["class"]),
        (_unref(icons).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nativeValues), (value, iconIndex) => {
                return (_openBlock(), _createBlock(_component_o_radio, {
                  key: value + iconIndex,
                  modelValue: _unref(computedAnywherConnector),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(computedAnywherConnector) ? (computedAnywherConnector).value = $event : null)),
                  "native-value": value.toLowerCase(),
                  placeholder: value,
                  rootClass: "button",
                  variant: _unref(computedAnywherConnector) === value.toLowerCase() ? 'success' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_o_icon, {
                      icon: _unref(icons)[iconIndex]
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(value), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "native-value", "placeholder", "variant"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_5
  ], 64))
}
}

})